import type { IconProps } from './../../models/icon';

export function ChevronRightIcon({
  width = 24,
  height = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M6.6001 0.857178L17.1429 11.4C17.2249 11.477 17.2904 11.5699 17.3349 11.6731C17.3797 11.7763 17.4027 11.8876 17.4027 12C17.4027 12.1125 17.3797 12.2237 17.3349 12.3269C17.2904 12.4301 17.2249 12.5231 17.1429 12.6L6.6001 23.1429"
      />
    </svg>
  );
}
